<template>
  <div style="margin-top: 10%;" class="fill-height" :style="{ minHeight: containerHeight + 'px' }">
    <div class="container">
      <div class="text-center"><h2>Please choose country</h2></div>
      <div class="filter">
         <div class="">
            <v-select v-model="region" hide-details outlined @change="getElections" :items="regions" label="Country" required></v-select>
         </div>
      </div>    
      <div v-if="region == ''">
        <div class="mt-3 mb-3 text-center">Or</div>
        <div class="filter">
           <v-btn color="secondary" @click="openRequest">Request for Election</v-btn>
        </div>
     </div>
      
      <div class="items">
         
          <div v-if="region != ''" >
             <div v-if="data.length == 0" class="nodata">No election right now</div>
             <div v-else class="mt-5">
                <Votefile :data="data" />
             </div>
          </div>
      </div>      
    </div>
    

   
    <v-dialog  v-model="requestPopup"  max-width="600">
      <v-card>
        <v-toolbar color="primary" title="Election Form" class="white--text">Election Request Form</v-toolbar>
        <div class="small-container">
          
          <div class="myrow">
            <div class="label-div">Full Name</div>
            <div class="input-div">
              <v-text-field hide-details outlined label="Full Name" placeholder="Full Name" v-model="formname"></v-text-field>
              <div class="errorcust" v-if="form.namerror != ''">{{ form.namerror }}</div>
            </div>
          </div>
          <div class="myrow">
            <div class="label-div">Organisation</div>
            <div class="input-div">
              <v-text-field hide-details outlined label="Organisation" placeholder="Organisation" v-model="formorganisation"></v-text-field>
              <div class="errorcust" v-if="form.organisationerror  != ''">{{ form.organisationerror }}</div>
            </div>
          </div>
          <div class="myrow">
            <div class="label-div">Country</div>
            <div class="input-div">
              <v-select v-model="formcountry" hide-details outlined  :items="regions" label="Country" required></v-select>
              <div class="errorcust" v-if="form.countryerror  != ''">{{ form.countryerror }}</div>
            </div>
          </div>
          <div class="myrow">
            <div class="label-div">Name of Election</div>
            <div class="input-div">
              <v-text-field hide-details outlined label="Name of Election" placeholder="Name of Election" v-model="formelectionname"></v-text-field>
              <div class="errorcust" v-if="form.electionnameerror  != ''">{{ form.electionnameerror }}</div>
            </div>
          </div>
          <div class="myrow">
            <div class="label-div">No. of Voters (approx)</div>
            <div class="input-div">
              <v-text-field hide-details outlined label="No. of Voters" placeholder="No. of Voters" v-model="formnoofvoters"></v-text-field>
            </div>
          </div>
          <div class="myrow">
            <div class="label-div">Phone Number</div>
            <div class="input-div">
              <v-text-field hide-details outlined label="Phone" placeholder="Phone Number" v-model="formphone"></v-text-field>
            </div>
          </div>
          <div class="myrow">
            <div class="label-div">Mobile Number </div>
            <div class="input-div">
              <v-text-field hide-details outlined label="Mobile" placeholder="Mobile Number" v-model="formmobile"></v-text-field>
              
            </div>
          </div>
          <div class="myrow">
            <div class="label-div">Email </div>
            <div class="input-div">
              <v-text-field hide-details outlined label="Email" placeholder="Email" v-model="formemail"></v-text-field>
              <div class="errorcust" v-if="form.emailerror  != ''">{{ form.emailerror }}</div>
            </div>
          </div>
          <div class="myrow">
            <div class="label-div">Password</div>
            <div class="input-div">
              <v-text-field hide-details type="password" outlined label="Password" placeholder="Password" v-model="formpassword"></v-text-field>
              <div class="errorcust" v-if="form.password  != ''">{{ form.password }}</div>
            </div>
          </div>
          <div class="myrow">
            <div class="label-div">Captcha</div>
            <div class="input-div">
              <!-- Google reCAPTCHA -->
              <div id="recaptcha" ref="recaptcha"></div>
            </div>
          </div>
          <div class="mt-5 mb-10 text-center">
             <v-btn color="secondary" :disabled="disableButton" @click="electionForm">Send</v-btn>
             <div class="mt-2 errorcust" :class="colorclass" v-if="showmsg != ''" v-html="showmsg"></div>
          </div>
        </div>
      </v-card>
   </v-dialog>    
    
  </div>
</template>
<script>
import { getUserTimezone } from '../plugins/timezone';
//import Web3 from 'web3';
//import { blockchainConfig } from '../../blockchainConfig';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { encryptionKey } from '../../config';

import Votefile from '../components/Votefile.vue';
 
export default {
  name: "Election",
  
  data() {
    return {
        region: "",
        regions: ["America", "Australia", "United Kingdom","New Zeland"],
        data:[],
        electionid:0,
        
       
        childdata:[],
        voteType:'',
        
        voteData:[],
        
        needcertificate:'',
        disableButton:false,
        showemailBlock:false,
        emailaddress:'',
        screenHeight: 0,
        screenWidth: 0,
        containerHeight:500,
        dialogTop: '100px',
        voter:'',
        pole:'',
        requestPopup:false,
        form:{namerror:'',organisationerror:'',electionnameerror:'',emailerror:'',password:'',countryerror:''},
        formname:'',
        formorganisation:'',
        formelectionname:'',
        formphone:'',
        formmobile:'',
        formemail:'',
        formpassword:'',
        formcountry:'',
        formnoofvoters:'',
        showmsg: '',
        captchaToken: null,
        colorclass:'',
        
        currentField: null
    }
  },
  components:{
      Votefile
  },    
  
  mounted() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if(typeof this.$route.params.region != "undefined")
    {
       this.region = this.$route.params.region;
       this.getElections();
    }
   
    if(this.screenWidth <= 768)
    {
      
       if(this.screenHeight == 932)
         this.containerHeight = 600;
       else
         this.containerHeight = this.screenHeight - 200; 
    } 
    window.addEventListener('resize', this.updateScreenHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenHeight);
  },
  methods:{
   
  openRequest(){
      this.requestPopup = true;
      this.$nextTick(() => {
        this.initRecaptcha();
      });
      
  },
  initRecaptcha() {
    const recaptchaElement = this.$refs.recaptcha;
    if (!recaptchaElement) {
      console.error("❌ reCAPTCHA element not found!");
      return;
    }

    console.log("✅ reCAPTCHA element found, initializing...");

    let attempts = 0;
    const checkRecaptcha = setInterval(() => {
      if (window.grecaptcha && window.grecaptcha.render) {
        clearInterval(checkRecaptcha);
        console.log("✅ Rendering reCAPTCHA...");

        this.recaptchaWidget = window.grecaptcha.render(recaptchaElement, {
          sitekey: "6Lep3OwtAAAAAEezeVmybmse-usMOtrRE73aPvhv", // Replace with your site key
          theme: "light",
        });
      } else {
        console.log(`🔄 Waiting for grecaptcha... (${++attempts})`);
        if (attempts > 10) {
          clearInterval(checkRecaptcha);
          console.error("❌ reCAPTCHA API failed to load.");
        }
      }
    }, 500);
  },
  async electionForm(){
     let error = 0
     if (window.grecaptcha && typeof window.grecaptcha.getResponse === "function") {
    const recaptchaResponse = window.grecaptcha.getResponse();

    if (!recaptchaResponse) {
      this.showmsg = "❌ Please complete the reCAPTCHA verification.";
      error = 1;
    }
  } else {
    this.showmsg = "⚠️ reCAPTCHA not loaded, please try again.";
    return;
  }
      if(this.formname == ''){
         this.form.namerror = 'Please enter name';
         error = 1;
      }
      else{
        this.form.namerror = '';
      }

      if(this.formorganisation == ''){
         this.form.organisationerror = 'Please enter organisation';
         error = 1;
      }
      else{
         this.form.organisationerror = '';
      }
      
      if(this.formelectionname == ''){
         this.form.electionnameerror = 'Please enter election name';
         error = 1;
      }
      else{
        this.form.electionnameerror = '';
      }

      // if(this.formphone == ''){
      //    this.form.phoneerror = 'Please enter phone number';
      //    error = 1;
      // }
      // else{
      //    this.form.phoneerror = '';
      // }

      if(this.formemail == ''){
         this.form.emailerror = 'Please enter email';
         error = 1;
      }
      else{
        this.form.emailerror = '';
      }

      if(this.formpassword == ''){
         this.form.password = 'Please enter password'
         error = 1;
      }
      else{
         this.form.password = '';
      }

      if(this.formcountry == ''){
         this.form.countryerror = 'Please select country';
         error = 1;
      }
      else{
        this.form.countryerror = '';
      }

      if(error == 0)
      {
        this.disableButton = true;
        let encryptedData = {
          country:this.formcountry,
          formname:this.formname,
          formorganisation:this.formorganisation,
          formelectionname:this.formelectionname,
          formphone:this.formphone,
          formemail:this.formemail,
          formpassword:this.formpassword,
          formmobile:this.formmobile,
          formnoofvoters:this.formnoofvoters,
        };
        axios.post('/election-request',{ myData: encryptedData}).then(response => 
        {
          this.disableButton = false; 
          if(response.data.status)
          {
            this.formname = '';
            this.formorganisation = '';
            this.formelectionname = '';
            this.formphone = '';
            this.formemail = '';
            this.formpassword = '';
            this.formmobile = '';
            this.showmsg = response.data.msg;
            this.colorclass = "text--green";
            setTimeout(() => {
              this.requestPopup = false;
              this.colorclass = '';
            }, 2000);
          }
          else
          {
            this.colorclass = '';
            this.showmsg = response.data.message;
          }
        });  
      }
  },
  isFutureDate(date) {
    const currentDate = new Date();
    return date < currentDate;
  },
  updateScreenHeight(){
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    if(this.screenWidth <= 768)
    {
      this.containerHeight = this.screenHeight - 200;
    } 
  },
  getElections()
  {
    this.showdialog = true;
    const userTimezone = getUserTimezone();
    const data = {
              country:this.region,
              timezone: userTimezone
            }; 
    this.disableButton = true;
    var encryptedData = this.encryptMe(data);
    this.$store.dispatch("getElectionsData",{ data:encryptedData }).then((response) =>
    {
       let encryptStr = response.data;
       let decrypted = this.decryptMe(encryptStr);
       let finalresult = this.unserializePhpArray(decrypted);
          
       if(response.status)
       {
          this.data = finalresult;
       }
       this.showdialog = false;
    });
  },
  timeElapsedHandler(key)
  {
      this.data[key].started = 1;
      this.data[key].time = '';
  },
  timeElapsedHandlerAnother(key)
  {
    this.data.splice(key, 1);
  },
  
  
    encryptMe(data){
      let iv = CryptoJS.lib.WordArray.random(16);
      let key = CryptoJS.enc.Base64.parse(encryptionKey);
      let options = {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      };
      let encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, options);

      encrypted = encrypted.toString();
      iv = CryptoJS.enc.Base64.stringify(iv);
      let result = {
            iv: iv,
            value: encrypted,
            mac: CryptoJS.HmacSHA256(iv + encrypted, key).toString()
        }
      result = JSON.stringify(result);
      result = CryptoJS.enc.Utf8.parse(result);
      let encryptedData = CryptoJS.enc.Base64.stringify(result);
      
      return encryptedData;
    },
    decryptMe(encryptStr){
      let encryptStrVal = CryptoJS.enc.Base64.parse(encryptStr);
      let encryptData = encryptStrVal.toString(CryptoJS.enc.Utf8);
          encryptData = JSON.parse(encryptData);
      let iv = CryptoJS.enc.Base64.parse(encryptData.iv);
      var decrypted = CryptoJS.AES.decrypt(encryptData.value,  CryptoJS.enc.Base64.parse(encryptionKey), {
            iv : iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
      decrypted = CryptoJS.enc.Utf8.stringify(decrypted); 
      
      return decrypted;
    },
   
    unserializePhpArray(serializedString) 
    {
      try {
        const start = serializedString.indexOf(':"');
        const jsonString = serializedString.substring(start + 2, serializedString.length - 2);
        const result = JSON.parse(jsonString);
        
        return result;
      } catch (error) 
      {
        console.error("Error deserializing PHP array:", error);
        return {}; // Return an empty object in case of error
       }
    },
    closedialog()
    {
      this.identitiesdialog = false;
    },
  
  }   
} 
</script>
<style scoped>
.errorlog{color: red; font-size: 14px;}
.filter{ width: 45%; margin: auto; border-radius: 8px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; padding: 15px; margin-bottom: 25px; margin-top: 10px;}
.nodata{text-align: center; font-weight: bold; margin-top: 10%;}


.small-container {width: 90%; margin: auto; padding: 10px;}
.myrow {display: flex; align-items: center; margin-top: 15px;}
.label-div {width: 35%; font-size: 18px;}
.input-div {width: 65%;}
.errorcust{color: red; font-size: 14px;}
@media only screen and (max-width: 600px) {
  .filter{width: 100%;}
}
.errorlog{color: red;font-size: 14px;margin-top: 10px;}
.filter button {width: 100%; height: 56px !important;}
</style>
<style>
.v-dialog.ballot{box-shadow:none !important;}
.v-dialog.ballot > .v-card > .v-card__text{padding: 0;}
.v-dialog.ballot > .v-card > .v-card__actions{padding: 0;}
.v-dialog.ballot .theme--light.v-card{background-color: transparent;}
.v-dialog .ballotaction{flex: 1; justify-content: center; margin-top: 5px;}
@media only screen and (max-width: 600px) {
  .filter{width: 100%;}
  .v-dialog.ballot{margin: 0;}
  .v-dialog__content {
    top: unset; /* Unset the fixed position on larger screens */
  }
}
@media(max-width: 430px) { 
.v-dialog__content {  align-items:flex-start; top: 6%; }
}

@media(max-width: 380px) { 
  .v-dialog__content {  top: 8%; }
  }
.errorcust.text--green{color:green !important}
</style>